import apiCaller from "./axios.service";

const baseUrl: string = "/v1/public/seamlessPlayer";

export const seamlessGetProvider = async <T>(
	provider_category: string,
	provider_type: string
): Promise<T> => {
	return apiCaller(`${baseUrl}/seamlessGetProvider`, {
		provider_category,
		provider_type,
	});
};

export const seamlessGetProfile = () => {
	return apiCaller(`${baseUrl}/seamlessGetProfile`);
};

export const seamlessGetUserBalance = () => {
	return apiCaller(`${baseUrl}/seamlessGetUserBalance`);
};

export const seamlessGetDepositWithdrawHistory = () => {
	return apiCaller(`${baseUrl}/seamlessGetDepositWithdrawHistory`);
};

export const getGameLseamlessGetGameListist = async <T>({
	game_list_game_category_id,
	game_list_provider_id,
	sort,
	current,
	pageSize,
}: {
	game_list_game_category_id?: string;
	game_list_provider_id?: number;
	sort?: any;
	current?: any;
	pageSize?: any;
}): Promise<T> => {
	return apiCaller(`${baseUrl}/seamlessGetGameList`, {
		game_list_game_category_id,
		game_list_provider_id,
		sort,
		current,
		pageSize,
	});
};

export const seamlessGetGameCategoryList = (
	game_category_provider_id: number
) => {
	return apiCaller(`${baseUrl}/seamlessGetGameCategoryList `, {
		game_category_provider_id,
	});
};

export const seamlessGenerateGameUrl = async <T>(
	game_list_game_id: number,
	player_game_provider_id: number,
	selectedType: string
): Promise<T> => {
	return apiCaller(`${baseUrl}/seamlessGenerateGameUrl`, {
		game_list_game_id,
		player_game_provider_id,
		selectedType,
	});
};

export const seamlessGenerateWebsiteGameUrl = async <T>(
	player_game_provider_id: number
): Promise<T> => {
	return apiCaller(`${baseUrl}/seamlessGenerateWebsiteGameUrl`, {
		player_game_provider_id,
	});
};

export const seamlessGetLatestPlayerToken = async <T>(
	token: any
): Promise<T> => {
	return apiCaller(`${baseUrl}/seamlessGetLatestPlayerToken`, {
		token,
	});
};

// reset password is decided via backend, here need to pass in token to identify the user
export const seamlessResetPassword = async (token: string): Promise<any> => {
	return apiCaller(`${baseUrl}/seamlessResetPassword`, {
		token,
	});
};

// change password is decided via backend, here need to pass in old and new password
export const seamlessChangePassword = async (
	old_password: string,
	new_password: string
): Promise<any> => {
	return apiCaller(`${baseUrl}/seamlessChangePassword`, {
		old_password: old_password.trim(),
		new_password: new_password.trim(),
	});
};
